import { styled } from "@tamagui/web";
import { Square } from "./Square";
const Circle = styled(Square, {
  name: "Circle",
  circular: true
});
export {
  Circle
};
//# sourceMappingURL=Circle.js.map
